import React from "react";
import PropTypes from "prop-types";

export default function ModalBody({ children }) {
  return (
    <div className="mt-2 w-full">
      <div className="text-sm text-gray-500">{children}</div>
    </div>
  );
}

ModalBody.propTypes = {
  children: PropTypes.any,
};
